const namespace = 'lt-yantr_';

export default {
    set(key, value, expiration) {
        try {
            const data = {
                value,
                expire: expiration ? Date.now() + expiration : null,
            };
            localStorage.setItem(`${namespace}${key}`, JSON.stringify(data));
        } catch {
            // Ignore the error
        }
    },
    get(key) {
        try {
            const item = localStorage.getItem(`${namespace}${key}`);
            if (item === null) {
                return null;
            }

            const data = JSON.parse(item);
            if (data.expire === null || data.expire >= Date.now()) {
                return data.value;
            }

            localStorage.removeItem(`${namespace}${key}`);
        } catch {
            // Ignore the error
        }
        return null;
    },
};
